import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Storage } from "@ionic/storage-angular";
import { AppSettings } from "./app-settings";
import { hasAdminModuleAccess, readStoredModuleAccess } from "./admin-access";
import { UserService } from "./user-service";

/**
 * Rolle- og modul-guard for ADMIN: krever Administrator og eksplisitt
 * tilgang til Modules.AdminSettings. Autentisering håndteres av
 * AuthService-guarden; denne sjekker kun rolle og modul.
 */
@Injectable({ providedIn: "root" })
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private storage: Storage,
    private userService: UserService
  ) {}

  async canActivate(): Promise<boolean> {
    let userLevel = AppSettings.UserLevel;

    if (userLevel == null) {
      userLevel = await this.storage.get(AppSettings.StorageKeys.Userlevel);
    }

    const moduleAccess = readStoredModuleAccess(
      this.userService.moduleAccess.getValue()
    );

    if (hasAdminModuleAccess(userLevel, moduleAccess)) {
      return true;
    }

    this.router.navigate(["/home"]);
    return false;
  }
}
